import { IntercomDataAttribute } from 'src/modules/common/types/intercom';

export const getIntercomDataAttribute = (type: IntercomDataAttribute, skpi = false) => {
  if (skpi) return undefined;
  return type;
};
